import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../../http_client";

import { fetchError, fetchRequest, fetchSuccess, previousFetchError, previousFetchSuccess } from "./actions";
import { ConversionsWidgetActionTypes } from "./types";

export function* handleFetch(action: ReturnType<typeof fetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/widgets/conversions/current/", action.payload, source.token);
    yield put(fetchSuccess(res.data));
  } catch (err) {
    yield put(fetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handlePreviousFetch(action: ReturnType<typeof fetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/widgets/conversions/previous/", action.payload, source.token);
    yield put(previousFetchSuccess(res.data));
  } catch (err) {
    yield put(previousFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchConversionsWidgetSagas(): SagaIterator {
  yield takeLatest(ConversionsWidgetActionTypes.FETCH_REQUEST, handleFetch);
  yield takeLatest(ConversionsWidgetActionTypes.PREVIOUS_FETCH_REQUEST, handlePreviousFetch);
}

export default watchConversionsWidgetSagas;
